import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

declare var $: any;

declare var gtag;

declare var types;

@Component({
  selector: 'personas-header-component',
  templateUrl: './personas-header.component.html',
  styleUrls: ['./personas-header.component.scss']
})




export class PersonasHeaderComponent implements OnInit {  

  @Input('HeaderHtml') HeaderHtml;
  @Input('menuHeaderHtml') menuHeaderHtml;
  @Input('BotonesDeSlides') BotonesDeSlides;
  @Input('menuFooterHtml') menuFooterHtml;
  @Input('idEvent') idEvent;

  @Output() uuid: EventEmitter<any> = new EventEmitter();
  @Output() padre: EventEmitter<any> = new EventEmitter();

  @Output() buscar: EventEmitter<any> = new EventEmitter();

  types=  [ 'type1', 'type2', 'type3' ];

  collapse = false;

  constructor() {
    
  }

  ngOnInit() {

    $('#info-dav').flickity({
      prevNextButtons: true,
      contain: true,
      freeScroll: true,
      pageDots: false
    });

console.log("idiomaEspañol--->ngOnInit--->"+localStorage.getItem("idiomaEspañol"));
    /*if(localStorage.getItem("idiomaEspañol")=="false"){
        localStorage.setItem("idiomaEspañol","true");
        this.idEvent="true";
    }*/
    


$('.makeMeList').each(function (index, element) {
        $(this).parent()
            .after()
            .append("<div class='scrollableList'><div class='selectedOption'></div><ul></ul></div>");

        $(element).each(function (idx, elm) {
            $('option', elm).each(function (id, el) {
                $('.scrollableList ul:last').append('<li>' + el.text + '</li>');
            });
            $('.scrollableList ul').hide();
            $('.makeMeUl').children('div.selectedOption').text("Select");
        });
        $('.scrollableList:last').children('div.selectedOption').text("Select");
    });

    $('.selectedOption').on('click', function () {
        $(this).next('ul').slideToggle(200);
        $('.selectedOption').not(this).next('ul').hide();
    });

    $('.scrollableList ul li').on('click', function () {
        var selectedLI = $(this).text();
        $(this).parent().prev('.selectedOption').text(selectedLI);
        $(this).parent('ul').hide();
    });

    $('.scrollableList').show();
    $('.makeMeList').hide();















    console.log("menuHeaderHtml- personas-->"+this.menuHeaderHtml);

     
  console.log("localStorage - header personas---->"+localStorage.getItem("idiomaEspañol"));
    //seleccion de idioma
    if (localStorage.getItem("idiomaEspañol") == "true"){ //español
      $("#toggle-button-checkbox").prop('checked', true);
      this.idEvent="true";
    }else{
      $("#toggle-button-checkbox").prop('checked', false); //ingles
      this.idEvent="false";
    }

    $(".layer").click(function (event) {
      $("#lg_slide").fadeIn(500, function () {
      });
    });

  }

  redireccionarAPaginaExistente(uuid) {

    this.uuid.emit(uuid);
   

    //ga('send', { 'hitType': 'pageview', 'page': '/contact-us/submitted/', 'title': 'Contact Us Submitted' });


        gtag('config', 'UA-118311338-3',{
        'page' : '/personas/'+uuid, 
        'page-path':'/personas/'+uuid,
        'page_title' : '/personas/'+uuid,
        'page_location' : '/personas/'+uuid
        });


    $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    $("#lg_slide").removeClass("active");
  }

  search() {
    this.buscar.emit(true);
    $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    // $("#lg_slide").removeClass("active");
    // $(".c-body").removeClass("overflow-hidden");

  }

  changedSlide(evento){
      console.log("evento idiomaEspañol-->"+evento);
      localStorage.setItem("idiomaEspañol",evento.toString());
      this.idEvent=evento.toString();
  }

  changedSlide2(){
    
    if(localStorage.getItem("idiomaEspañol")=="false"){
        localStorage.setItem("idiomaEspañol","true");
        this.idEvent="true";
    }else{
        localStorage.setItem("idiomaEspañol","false");
        this.idEvent="false";
    }

    

  }

  functionsjs2() {
    setTimeout(function () {
                    if ($.fn.fullpage.destroy) {
                      $.fn.fullpage.destroy('all');
                      // console.warn("$.fn.fullpage.destroy");
                    }
    
                    setTimeout(function () {
                      $('#fullpage').fullpage({
                        // anchors: ['uno', 'dos', 'tres', 'cuatro'],
                        menu: '#myMenu',
                        scrollingSpeed: 1000,
                        autoScrolling: true,
                        scrollOverflow: false,
                        resize: false,
                        
                        keyboardScrolling: false,
                        afterRender: function () {
                          var $map = document.getElementById('inner-map');
                          var $items = $('#myMenu li');
                          var $next = $('#fp-id-1');
    
                          $items.removeClass('custom-class-active');
                          $next.addClass('example custom-class-active');
                        },
                        onLeave: function(index, nextIndex, direction) {
                          var $items = $('#myMenu li');
                          var $next = $('#fp-id-'+nextIndex);
    
                          $items.removeClass('custom-class-active');
                          $next.addClass('custom-class-active');
                        }
                      });
                    }, 100);
                  }, 75);
    
    }




}
